import { call, put, takeEvery } from 'redux-saga/effects';

import Api from '../lib/Api';

import {
  FETCH_EVENTS_REQUESTED,
  FETCH_TOP_PRO_LINK_REQUESTED,
  FETCH_PRO_FUNNEL_REQUESTED,
  FETCH_CLIENT_FUNNEL_REQUESTED,
  FETCH_STATISTIC_REQUESTED,
} from '../store/analytics/actionTypes';
import {
  fetchClientFunnelFailed, fetchClientFunnelSucceeded, fetchEventsFailed, fetchEventsSucceeded,
  fetchProFunnelFailed,
  fetchProFunnelSucceeded,
  fetchStatisticFailed,
  fetchStatisticSucceeded, fetchTopProLinksFailed, fetchTopProLinksSucceeded
} from '../store/analytics/actions';

const _getAnalyticsListRequested = () => {
  return Api.getAnalyticsList()
    .then((response) => response)
    .catch((e) => e.response);
};

const _getStatisticRequested = () => {
  return Api.getStatistic()
    .then((response) => response)
    .catch((e) => e.response);
};

const _getTopProLinksRequested = () => {
  return Api.getTopProLinks()
    .then((response) => response)
    .catch((e) => e.response);
};

const _getProFunnelRequested = () => {
  return Api.getProFunnel()
    .then((response) => response)
    .catch((e) => e.response);
};

const _getClientFunnelRequested = () => {
  return Api.getClientFunnel()
    .then((response) => response)
    .catch((e) => e.response);
};

function* fetchEvents() {
  try {
    const response = yield call(_getAnalyticsListRequested);
    yield put(fetchEventsSucceeded({ events: response.data.data }));
  } catch (error) {
    yield put(fetchEventsFailed(error));
  }
}
function* fetchStatistic() {
  try {
    const response = yield call(_getStatisticRequested);
    yield put(fetchStatisticSucceeded({ statistic: response.data }));
  } catch (error) {
    yield put(fetchStatisticFailed(error));
  }
}

function* fetchTopProLinks() {
  try {
    const response = yield call(_getTopProLinksRequested);
    yield put(fetchTopProLinksSucceeded({ events: response.data.data }));
  } catch (error) {
    yield put(fetchTopProLinksFailed(error));
  }
}

function* fetchProFunnel() {
  try {
    const response = yield call(_getProFunnelRequested);
    yield put(fetchProFunnelSucceeded({ events: response.data.data }));
  } catch (error) {
    yield put(fetchProFunnelFailed(error));
  }
}

function* fetchClientFunnel() {
  try {
    const response = yield call(_getClientFunnelRequested);
    yield put(fetchClientFunnelSucceeded({ events: response.data.data }));
  } catch (error) {
    yield put(fetchClientFunnelFailed(error));
  }
}

function* AnalyticsSaga() {
  yield takeEvery(FETCH_EVENTS_REQUESTED, fetchEvents);
  yield takeEvery(FETCH_STATISTIC_REQUESTED, fetchStatistic);
  yield takeEvery(FETCH_TOP_PRO_LINK_REQUESTED, fetchTopProLinks);
  yield takeEvery(FETCH_PRO_FUNNEL_REQUESTED, fetchProFunnel);
  yield takeEvery(FETCH_CLIENT_FUNNEL_REQUESTED, fetchClientFunnel);
}

export default AnalyticsSaga;



// WEBPACK FOOTER //
// ./src/saga/analytics.js